/**
 * Генерирует slug из текста
 * @param {string} text - Текст для преобразования в slug
 * @returns {string} - slug в формате kebab-case
 */
export default function getSlug (text) {
  if (!text) return ''
  // Транслитерация кириллицы в латиницу
  const translitMap = {
    а: 'a',
    б: 'b',
    в: 'v',
    г: 'g',
    д: 'd',
    е: 'e',
    ё: 'yo',
    ж: 'zh',
    з: 'z',
    и: 'i',
    й: 'y',
    к: 'k',
    л: 'l',
    м: 'm',
    н: 'n',
    о: 'o',
    п: 'p',
    р: 'r',
    с: 's',
    т: 't',
    у: 'u',
    ф: 'f',
    х: 'h',
    ц: 'ts',
    ч: 'ch',
    ш: 'sh',
    щ: 'sch',
    ъ: '',
    ы: 'y',
    ь: '',
    э: 'e',
    ю: 'yu',
    я: 'ya',
    А: 'A',
    Б: 'B',
    В: 'V',
    Г: 'G',
    Д: 'D',
    Е: 'E',
    Ё: 'Yo',
    Ж: 'Zh',
    З: 'Z',
    И: 'I',
    Й: 'Y',
    К: 'K',
    Л: 'L',
    М: 'M',
    Н: 'N',
    О: 'O',
    П: 'P',
    Р: 'R',
    С: 'S',
    Т: 'T',
    У: 'U',
    Ф: 'F',
    Х: 'H',
    Ц: 'Ts',
    Ч: 'Ch',
    Ш: 'Sh',
    Щ: 'Sch',
    Ъ: '',
    Ы: 'Y',
    Ь: '',
    Э: 'E',
    Ю: 'Yu',
    Я: 'Ya'
  }
  let slug = text
  // Транслитерация
  slug = slug.split('').map(char => translitMap[char] || char).join('')
  // Приведение к нижнему регистру
  slug = slug.toLowerCase()
  // Замена пробелов и небуквенных символов на дефисы
  slug = slug.replace(/[^a-z0-9]+/g, '-')
  // Удаление дефисов в начале и конце
  slug = slug.replace(/^-+|-+$/g, '')
  // Удаление множественных дефисов
  slug = slug.replace(/-+/g, '-')
  return slug
}
